"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateUserInfoFailureAction = exports.updateUserInfoSuccessAction = exports.updateUserInfoRequestAction = exports.refreshTokenSuccessAction = exports.refreshTokenFailureAction = exports.refreshTokenRequestAction = exports.updateUserLanguageFailure = exports.updateUserLanguageSuccess = exports.updateUserLanguage = exports.fetchUserFeaturesSuccess = exports.fetchUserFeaturesFailure = exports.fetchUserFeaturesRequest = exports.getUserinfoSuccessAction = exports.getUserinfoFailureAction = exports.getUserinfoRequestAction = void 0;
const ActionTypes = require("../../actionTypes/auth/current");
const getUserinfoRequestAction = () => ({
    type: ActionTypes.GET_USERINFO_REQUEST
});
exports.getUserinfoRequestAction = getUserinfoRequestAction;
const getUserinfoFailureAction = (error) => ({
    type: ActionTypes.GET_USERINFO_FAILURE,
    payload: error
});
exports.getUserinfoFailureAction = getUserinfoFailureAction;
const getUserinfoSuccessAction = (user) => ({
    type: ActionTypes.GET_USERINFO_SUCCESS,
    payload: user
});
exports.getUserinfoSuccessAction = getUserinfoSuccessAction;
const fetchUserFeaturesRequest = () => ({
    type: ActionTypes.FETCH_USER_FEATURES_REQUEST
});
exports.fetchUserFeaturesRequest = fetchUserFeaturesRequest;
const fetchUserFeaturesFailure = (error) => ({
    type: ActionTypes.FETCH_USER_FEATURES_FAILURE,
    payload: error
});
exports.fetchUserFeaturesFailure = fetchUserFeaturesFailure;
const fetchUserFeaturesSuccess = (features) => ({
    type: ActionTypes.FETCH_USER_FEATURES_SUCCESS,
    payload: features
});
exports.fetchUserFeaturesSuccess = fetchUserFeaturesSuccess;
const updateUserLanguage = (language) => ({
    type: ActionTypes.UPDATE_USER_LANGUAGE,
    payload: language
});
exports.updateUserLanguage = updateUserLanguage;
const updateUserLanguageSuccess = (message) => ({
    type: ActionTypes.UPDATE_USER_LANGUAGE_SUCCESS,
    payload: message
});
exports.updateUserLanguageSuccess = updateUserLanguageSuccess;
const updateUserLanguageFailure = (payload) => ({
    type: ActionTypes.UPDATE_USER_LANGUAGE_FAILURE,
    payload
});
exports.updateUserLanguageFailure = updateUserLanguageFailure;
const refreshTokenRequestAction = () => ({
    type: ActionTypes.REFRESH_TOKEN_REQUEST
});
exports.refreshTokenRequestAction = refreshTokenRequestAction;
const refreshTokenFailureAction = (error) => ({
    type: ActionTypes.REFRESH_TOKEN_FAILURE,
    payload: error
});
exports.refreshTokenFailureAction = refreshTokenFailureAction;
const refreshTokenSuccessAction = (token) => ({
    type: ActionTypes.REFRESH_TOKEN_SUCCESS,
    payload: token
});
exports.refreshTokenSuccessAction = refreshTokenSuccessAction;
const updateUserInfoRequestAction = (props) => ({
    type: ActionTypes.UPDATE_USER_INFO_REQUEST,
    payload: props
});
exports.updateUserInfoRequestAction = updateUserInfoRequestAction;
const updateUserInfoSuccessAction = (user) => ({
    type: ActionTypes.UPDATE_USER_INFO_SUCCESS,
    payload: user
});
exports.updateUserInfoSuccessAction = updateUserInfoSuccessAction;
const updateUserInfoFailureAction = (errors) => ({
    type: ActionTypes.UPDATE_USER_INFO_FAILURE,
    payload: errors
});
exports.updateUserInfoFailureAction = updateUserInfoFailureAction;
//# sourceMappingURL=current.js.map